import React from 'react';
import { Link } from 'react-router-dom';
import AboutImg from '../../assets/img/AboutUs/aboutus.jpg';

const About: React.FC = () => {
  return (
    <div className="about-page">
      <div className="breadcrumbs">
        <div className="shell breadcrumbs-inner">
          <h1>About Us</h1>
          <ul className="breadcrumb-list">
            <li><Link to="/">Home</Link></li>
            <li className="active">About Us</li>
          </ul>
        </div>
      </div>

      <div className="shell">
        <div className="hero-grid" style={{ padding: '40px 0' }}>
          <div className="hero-copy">
            <p className="lead">
              ONESOFT is a privately owned company focussing on providing IT consulting services, 
              offshore web development and software development, re-engineering solutions and 
              ready-to-deploy business applications for a number of industries including e-commerce, 
              banking and finance, Medicine, Healthcare, Aviation & manufacturing.
            </p>
            <p style={{ color: 'var(--text-secondary)', marginBottom: '20px' }}>
              Our services and solutions are designed with a focus on secure, scalable, expandable 
              and reliable business systems. Through our low cost, high quality and reliable software 
              services, we serve our clients giving them value for money and thus client satisfaction.
            </p>
            <p>
              You can find detailed information about our company below. If you need any additional 
              information, do not hesitate to <Link to="/contact" className="text-gradient" style={{ fontWeight: 'bold' }}>Contact US</Link>
            </p>
            
            <ul className="unstyled-list" style={{ marginTop: '20px' }}>
              <li style={{ marginBottom: '12px' }}><span style={{ color: 'var(--accent)', marginRight: '10px' }}>✓</span> Specialized IT Consulting</li>
              <li style={{ marginBottom: '12px' }}><span style={{ color: 'var(--accent)', marginRight: '10px' }}>✓</span> Offshore Web Development</li>
              <li style={{ marginBottom: '12px' }}><span style={{ color: 'var(--accent)', marginRight: '10px' }}>✓</span> Software Re-engineering</li>
              <li style={{ marginBottom: '12px' }}><span style={{ color: 'var(--accent)', marginRight: '10px' }}>✓</span> Ready-to-deploy applications</li>
              <li style={{ marginBottom: '12px' }}><span style={{ color: 'var(--accent)', marginRight: '10px' }}>✓</span> Secure & Scalable systems</li>
            </ul>
          </div>
          <div className="hero-visual">
            <div className="glass-card" style={{ padding: '0' }}>
              <img src={AboutImg} alt="About Us" style={{ width: '100%', borderRadius: '20px' }} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
